import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

// 未读提醒请求序号：并发时只认最后一次请求的结果。
// 典型场景——刚在反馈页标记完已读，导航栏那次在途的旧请求又把数字刷回来。
let notifyReqSeq = 0

// 从localStorage读取存储的状态
const loadState = () => {
  try {
    const savedState = localStorage.getItem('userState')
    if (savedState) {
      return JSON.parse(savedState)
    }
  } catch (error) {
    console.error('加载状态失败:', error)
  }
  return {
    isAuthenticated: false,
    info: null
  }
}

// 保存状态到localStorage
const saveState = (state) => {
  try {
    localStorage.setItem('userState', JSON.stringify(state))
  } catch (error) {
    console.error('保存状态失败:', error)
  }
}

export default new Vuex.Store({
  state: {
    user: loadState(),
    courses: [],
    currentCourse: null,
    // 导航栏未读反馈提醒。刻意不持久化：每次进站/刷新重新问后端要，
    // 避免本地存的旧数字盖掉真实状态。
    notify: {
      unread: 0,
      isAdmin: false
    }
  },
  mutations: {
    SET_AUTH(state, isAuthenticated) {
      state.user.isAuthenticated = isAuthenticated
      saveState(state.user)
    },
    SET_USER_INFO(state, userInfo) {
      state.user.info = userInfo
      saveState(state.user)
    },
    SET_COURSES(state, courses) {
      state.courses = courses
    },
    SET_CURRENT_COURSE(state, course) {
      state.currentCourse = course
    },
    // 更新导航栏未读反馈提醒
    SET_NOTIFY(state, payload) {
      if (!payload) return
      state.notify.unread = payload.unread || 0
      state.notify.isAdmin = !!payload.isAdmin
    },
    LOGOUT(state) {
      // 清除状态
      state.user.isAuthenticated = false
      state.user.info = null
      state.currentCourse = null
      state.notify.unread = 0
      state.notify.isAdmin = false
      
      // 清除本地存储中的认证信息
      localStorage.removeItem('userState')
      localStorage.removeItem('token')
      localStorage.removeItem('savedUsername')
      
      // 清除会话存储中的认证信息
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('userState')
      
      // 清除Cookie中的认证信息
      document.cookie.split(';').forEach(cookie => {
        const name = cookie.split('=')[0].trim()
        if (name.includes('token') || name.includes('user')) {
          document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
        }
      })
    }
  },
  actions: {
    // login({ commit }, userData) {
    //   return new Promise((resolve) => {
    //     // 模拟登录API调用
    //     setTimeout(() => {
    //       const userInfo = {
    //         id: 1,
    //         name: userData.username,
    //         avatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'
    //       }
          
    //       // 生成模拟token（实际项目中应该从服务器获取）
    //       const token = 'mock-jwt-token-' + Date.now()
          
    //       // 保存token到localStorage
    //       localStorage.setItem('token', token)
          
    //       // 更新状态
    //       commit('SET_AUTH', true)
    //       commit('SET_USER_INFO', userInfo)
          
    //       resolve()
    //     }, 500)
    //   })
    // },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('LOGOUT')
        resolve()
      })
    },
    fetchCourses({ commit }) {
      // 模拟获取课程数据
      const mockCourses = [
        { id: 1, title: 'Vue.js入门教程', type: 'video', duration: '2.5小时', cover: 'https://picsum.photos/300/200' },
        { id: 2, title: 'JavaScript高级编程', type: 'video', duration: '3小时', cover: 'https://picsum.photos/300/201' },
        { id: 3, title: 'Web开发PPT教程', type: 'ppt', pages: 45, cover: 'https://picsum.photos/300/202' },
        { id: 4, title: 'CSS深入理解', type: 'ppt', pages: 30, cover: 'https://picsum.photos/300/203' }
      ]
      commit('SET_COURSES', mockCourses)
    },

    /**
     * 拉取导航栏未读反馈提醒数
     *
     * 后端 /feedback/unread-count 按身份返回不同口径：
     *   管理员   → 待处理（pending）反馈总条数
     *   普通用户 → 自己提交的、管理员已处理但自己没看过的条数
     * 任何异常（未登录 / 接口未部署 / 网络抖动）都静默吞掉——
     * 这只是个提醒，不能影响页面本身。
     */
    async refreshNotify({ commit }) {
      if (!localStorage.getItem('token')) {
        commit('SET_NOTIFY', { unread: 0, isAdmin: false })
        return
      }
      const seq = ++notifyReqSeq
      try {
        const { data } = await axios.get('/feedback/unread-count')
        if (seq !== notifyReqSeq) return   // 已有更新的请求发出，丢弃本次结果
        commit('SET_NOTIFY', {
          unread: (data && data.count) || 0,
          isAdmin: !!(data && data.is_admin)
        })
      } catch (e) {
        // 静默失败
      }
    }
  }
})